module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app"
  }, [_c('form', {
    staticClass: "login-form",
    attrs: {
      "action": ""
    },
    on: {
      "submit": _vm.submitVerifyCode
    }
  }, [_c('div', {
    staticClass: "big-tips"
  }, [_vm._v("\n            发送短信验证码至电子健康卡手机号:\n            "), _c('br'), _vm._v(" "), _c('label', {
    staticClass: "f-strongest"
  }, [_vm._v(_vm._s(_vm._f("dotted")(_vm.mobileNo)))])]), _vm._v(" "), _c('verify-code', {
    attrs: {
      "namespace": "residentHealthRecordCode",
      "url": "/app/user/send",
      "param": _vm.sendCodeParam
    },
    on: {
      "send-finish": _vm.sendFinish
    },
    model: {
      value: (_vm.verifyCode),
      callback: function($$v) {
        _vm.verifyCode = $$v
      },
      expression: "verifyCode"
    }
  }), _vm._v(" "), _vm._m(0)], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "padding": "0.75rem 0.5rem"
    }
  }, [_c('button', {
    staticClass: "btn-ok phone-click-next",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("下一步")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-833c1fcc","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modules/residentHealthRecord/sendVerifyCode.vue
// module id = 864
// module chunks = 0